import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import GoldShieldLogo from "@/components/GoldShieldLogo";

const WebsiteDisclaimer = () => (
  <div className="min-h-screen bg-slate-950 text-white flex flex-col">
    <SEO 
      title="Website Disclaimer | RTS EXPRESS LTD"
      description="Website disclaimer for RTS EXPRESS LTD. Information about the use of our website and limitations of liability."
      path="/website-disclaimer"
    />
    <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="legal-nav-home-link">
          <GoldShieldLogo className="w-10 h-12" />
          <div className="flex flex-col">
            <span className="text-xl font-bold text-white tracking-tight leading-tight">RTS EXPRESS</span>
            <span className="text-[10px] text-slate-400 tracking-wide">SAME DAY COURIER</span>
          </div>
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <a href="/#services" className="text-slate-400 hover:text-white transition-colors" data-testid="legal-nav-services-link">Services</a>
          <a href="/#how-it-works" className="text-slate-400 hover:text-white transition-colors" data-testid="legal-nav-how-link">How It Works</a>
          <a href="/#contact" className="text-slate-400 hover:text-white transition-colors" data-testid="legal-nav-contact-link">Contact</a>
        </div>
        <Link to="/get-quote" className="bg-green-500 text-slate-950 hover:bg-green-500/90 font-semibold px-6 py-2 rounded-sm transition-colors" data-testid="legal-get-quote-btn">
          Get a Quote
        </Link>
      </div>
    </nav>

    <main className="flex-1 pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl md:text-5xl font-bold mb-6" data-testid="legal-page-title">Website Disclaimer</h1>
        <div className="text-slate-300 space-y-4" data-testid="legal-page-content">
          <p><strong>Last updated: 17 February 2026</strong></p>
          <p>
            The information on this website is provided for general information only. While we aim to keep it accurate and up to date, RTS EXPRESS LTD makes no warranties of any kind (express or implied) about completeness, accuracy, reliability or availability.
          </p>

          <h2 className="text-2xl font-semibold text-white">Service availability and quotations</h2>
          <p>
            Service availability, timing and pricing depend on operational capacity, distance and the information provided. A quote request is not a confirmed booking. A booking is confirmed only when we issue a quotation and you accept it by payment.
          </p>

          <h2 className="text-2xl font-semibold text-white">External links</h2>
          <p>
            This website may include links to third-party websites. We are not responsible for the content or practices of those third parties.
          </p>

          <h2 className="text-2xl font-semibold text-white">Limitation of liability</h2>
          <p>
            To the fullest extent permitted by law, RTS EXPRESS LTD will not be liable for any loss or damage arising from reliance on information on this website or from temporary unavailability of the site. This does not exclude liability that cannot be excluded under law.
          </p>

          <h2 className="text-2xl font-semibold text-white">Contact</h2>
          <p>
            Questions about this disclaimer: info@rtsexpress.co.uk
          </p>
          <p>
            Contact: info@rtsexpress.co.uk
          </p>
        </div>
      </div>
    </main>

    <footer className="border-t border-slate-800 bg-slate-950">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm" data-testid="legal-footer-copyright">
            Copyright {new Date().getFullYear()} RTS EXPRESS LTD. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-slate-500">
            <span>Company No: 13973121</span>
            <span className="text-slate-700">|</span>
            <span>VAT No: GB414935787</span>
            <span className="text-slate-700">|</span>
            <span>Payment required before collection</span>
          </div>
        </div>
        <p className="mt-2 text-slate-500 text-sm" data-testid="legal-footer-email">
          info@rtsexpress.co.uk
        </p>
        <div className="mt-4 flex flex-wrap gap-4 text-sm">
          <Link to="/terms-and-conditions" className="text-slate-400 hover:text-white transition-colors" data-testid="legal-footer-terms-link">
            Terms &amp; Conditions
          </Link>
          <Link to="/privacy-policy" className="text-slate-400 hover:text-white transition-colors" data-testid="legal-footer-privacy-link">
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" className="text-slate-400 hover:text-white transition-colors" data-testid="legal-footer-cookie-link">
            Cookie Policy
          </Link>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
            className="text-slate-400 hover:text-white transition-colors"
            data-testid="legal-footer-cookie-settings-button"
          >
            Cookie Settings
          </button>
          <Link to="/website-disclaimer" className="text-slate-400 hover:text-white transition-colors" data-testid="legal-footer-disclaimer-link">
            Website Disclaimer
          </Link>
        </div>
      </div>
    </footer>
  </div>
);

export default WebsiteDisclaimer;